import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "py-2",
  "data-cy": "template-desc-div"
};
const _hoisted_2 = {
  class: "flex justify-between space-x-2 tw"
};
const _hoisted_3 = {
  class: "w-1/2 py-2"
};
const _hoisted_4 = {
  class: "w-1/2 flex gap-2 py-2"
};
const _hoisted_5 = {
  class: "w-1/2 pt-8"
};
const _hoisted_6 = {
  key: 0,
  class: "split-half"
};
const _hoisted_7 = {
  class: "flex space-x-2 tw py-2"
};
const _hoisted_8 = {
  class: "w-1/2",
  "data-replay-unmask": ""
};
const _hoisted_9 = {
  class: "w-1/2"
};
const _hoisted_10 = {
  key: 2,
  class: "py-2"
};
const _hoisted_11 = {
  class: "py-1"
};
const _hoisted_12 = {
  src: "/img/qb16x16.png"
};
const _hoisted_13 = ["onClick"];
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlTextField from '@/components/LlTextField.vue';
import ExpenseCodePicker from '@/components/ExpenseCodePicker.vue';
import AttachmentPicker from '@/components/AttachmentPicker.vue';
import MultipleAttachmentPreview from '@/components/MultipleAttachmentPreview.vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import DescriptionPreviewModal from './DescriptionPreviewModal.vue';
import LlResizableTextarea from '@/components/LlResizableTextarea.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import LlCheckbox from '@/components/LlCheckbox.vue';
import RemoveLineItemModal from './modalception/RemoveLineItemModal.vue';
import { onMounted, onBeforeUnmount, reactive, computed, ref } from 'vue';
import SelectUser from '@/components/SelectUser.vue';
import { storeToRefs } from 'pinia';
import { attachmentsToFileSelector, truncateFileName } from '@/utils/attachmentsToFileSelector';
import axios from 'axios';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import LlTextarea from '@/components/LlTextarea.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
export default {
  __name: 'ExpenseLineItem',
  props: {
    isNewExpense: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const companyStore = useCompanyStore();
    const {
      handleError
    } = useSnackbarHandler();
    const {
      getIsLocked
    } = useInvoiceState();
    const {
      permissions
    } = storeToRefs(useMeStore());
    const {
      removeLineItem
    } = invoiceState;
    const {
      selectedLineItem
    } = invoiceEditorStore;
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      companySettings
    } = storeToRefs(companyStore);
    const {
      features
    } = storeToRefs(useMeStore());
    const customFlagLabel = companySettings.value.labels?.customFlag || false;
    const emit = __emit;
    const props = __props;
    const expenseModalState = reactive({
      loading: false,
      showRemoveLineModal: false,
      form: {
        id: '',
        description: '',
        descriptionPreview: '',
        date: '',
        account: {
          id: '',
          name: ''
        },
        codes: {
          task: {
            id: null,
            label: null
          }
        },
        amount: '',
        includeCodes: false,
        showAccountTotals: false,
        includeHours: false,
        expenses: [{
          code: {
            id: '',
            label: ''
          },
          amount: '',
          quantity: '',
          rate: '',
          total: '',
          description: ''
        }],
        standard: null
      },
      loaded: false,
      filesToUpload: [],
      fileSelector: [],
      selectedFileIndex: 0,
      showAttachmentPicker: false,
      showAttachmentPreview: false,
      isSaving: false
    });

    // Modal instance counters to force fresh component creation
    const modalCounters = reactive({
      removeLine: 0,
      attachmentPicker: 0,
      attachmentPreview: 0
    });
    const deleteAttachmentDialog = ref(null);

    // Cleanup nested modal states on unmount to prevent overlay accumulation
    onBeforeUnmount(() => {
      expenseModalState.showRemoveLineModal = false;
      expenseModalState.showAttachmentPicker = false;
      expenseModalState.showAttachmentPreview = false;
    });

    // Helper function to centralize line item updates
    const updateExpenseLineItem = (expenseData = {}) => {
      const dataToUpdate = expenseData.id ? {
        ...expenseModalState.form,
        ...expenseData
      } : expenseModalState.form;
      invoiceState.updateLineItem(dataToUpdate);
    };
    const isAmountEmpty = value => {
      return value === null || value === undefined || value === '';
    };

    // Computed properties for validation
    const amountError = computed(() => {
      return isAmountEmpty(expenseModalState.form.amount);
    });
    const applyDisabled = computed(() => {
      return amountError.value;
    });
    onMounted(async () => {
      expenseModalState.loading = true;
      expenseModalState.form = JSON.parse(JSON.stringify(selectedLineItem));
      expenseModalState.fileSelector = attachmentsToFileSelector(selectedLineItem.expenses[0].attachments);

      // Seed the code picker's v-model; ExpenseCodePicker resolves the full
      // code object (label) against the expense code list it loads on mount.
      if (selectedLineItem.expenses[0].code?.id) {
        expenseModalState.form.codes ??= {
          task: {
            id: null,
            label: null
          }
        };
        expenseModalState.form.codes.task = {
          ...selectedLineItem.expenses[0].code
        };
      } else {
        expenseModalState.form.codes = {
          task: {
            id: '',
            label: ''
          }
        };
      }
      expenseModalState.loading = false;
    });
    const confirm = () => {
      if (applyDisabled.value) {
        return;
      }
      expenseModalState.isSaving = true;
      expenseModalState.form.description = expenseModalState.form.descriptionPreview;
      expenseModalState.form.amount = parseFloat(expenseModalState.form.amount);
      expenseModalState.form.expenses[0].amount = expenseModalState.form.amount;
      if (expenseModalState.form.expenses[0].code) {
        expenseModalState.form.codes = {
          task: {
            id: expenseModalState.form.expenses[0].code?.id
          }
        };
      }
      updateExpenseLineItem();
      expenseModalState.isSaving = false;
      emit('cancel');
    };
    const saveNewExpense = async () => {
      if (applyDisabled.value) {
        return;
      }
      expenseModalState.isSaving = true;
      expenseModalState.form.expenses.forEach(ex => {
        ex.amount = parseFloat(expenseModalState.form.amount);
        ex.description = expenseModalState.form.description;
      });
      try {
        let newExpense = await invoiceEditorStore.saveNewExpense(expenseModalState.form, true // Keep the modal open while we handle attachments
        );

        // Check if newExpense is valid before proceeding
        if (newExpense) {
          expenseModalState.form.expenses[0] = {
            ...newExpense
          };
          if (expenseModalState.filesToUpload.length > 0) {
            await uploadAttachment(newExpense.id);
          } else {
            // Update line item with the newly created expense data
            updateExpenseLineItem({
              id: newExpense.id,
              expenses: [{
                ...expenseModalState.form.expenses[0],
                // Create a fresh reference for attachments array to trigger reactivity
                attachments: expenseModalState.form.expenses[0].attachments || []
              }]
            });
          }

          // Only close modal on successful expense creation
          invoiceEditorStore.showNewExpenseModal = false;
        }
      } catch (error) {
        // Handle any thrown errors - keep modal open for user to retry
        handleError(error || 'Failed to create expense');
      } finally {
        expenseModalState.isSaving = false;
      }
    };
    const selectedStandard = () => {
      if (expenseModalState.form.standard) {
        expenseModalState.form = {
          ...expenseModalState.form,
          ...expenseModalState.form.standard,
          codes: {
            task: expenseModalState.form.standard.code
          }
        };
      }
      handleCodeChange();
    };
    const removeOrDeleteLineItem = ({
      action
    } = {}) => {
      if (action) {
        expenseModalState.form.status = action;
      }
      removeLineItem(expenseModalState.form);
      emit('cancel');
    };
    const handleAccountChange = () => {};
    const handleDateChange = () => {
      expenseModalState.form.expenses.forEach(e => e.date = expenseModalState.form.date);
      // dateChanged will trigger a re-sort when we save
      expenseModalState.form.dateChanged = !invoiceEditorStore.sameDate(expenseModalState.form.date, selectedLineItem.date);
    };
    const handleSelectedAttachment = attachmentData => {
      const files = attachmentData;
      expenseModalState.fileSelector.unshift(...files);
      expenseModalState.filesToUpload.unshift(...files);
      expenseModalState.showAttachmentPreview = true;
      if (!props.isNewExpense) uploadAttachment(expenseModalState.form.expenses[0].id);
    };
    const removeLineModal = () => {
      expenseModalState.showRemoveLineModal = true;
    };
    const handleCodeChange = () => {
      expenseModalState.form.expenses.forEach(ex => {
        ex.code = expenseModalState.form.codes?.task;
      });
    };

    // Upload Attachment
    const uploadAttachment = async id => {
      const formData = new FormData();
      expenseModalState.filesToUpload.forEach(file => formData.append('attachments', file));
      try {
        const response = await axios.put(`/expenses/${id}/attachments`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        expenseModalState.form.expenses[0].attachments ??= [];
        const newAttachments = response.data;
        newAttachments.forEach(att => {
          expenseModalState.form.expenses[0].attachments.push(att);
        });
        expenseModalState.fileSelector = attachmentsToFileSelector(expenseModalState.form.expenses[0].attachments);
        expenseModalState.filesToUpload = [];
        updateExpenseLineItem({
          id: id,
          expenses: [{
            ...expenseModalState.form.expenses[0],
            attachments: expenseModalState.form.expenses[0].attachments
          }]
        });
      } catch (error) {
        handleError(error || 'Failed to upload attachment');
      }
    };

    // Delete Attachment from Server
    const deleteAttachments = fileToRemove => {
      expenseModalState.attachmentToDelete = fileToRemove;
      deleteAttachmentDialog.value.open();
    };
    const confirmDeleteAttachment = async () => {
      const fileToRemove = expenseModalState.attachmentToDelete;
      if (!props.isNewExpense) {
        if (fileToRemove.expenseAttachmentId) {
          try {
            await axios.delete(`/expenses/attachment?expenseAttachmentId=${fileToRemove.expenseAttachmentId}`);
            expenseModalState.fileSelector = expenseModalState.fileSelector.filter(file => file.expenseAttachmentId !== fileToRemove.expenseAttachmentId);
          } catch (error) {
            handleError(error || 'Failed to upload attachment');
          }
        } else {
          expenseModalState.attachmentToDelete = fileToRemove;
          expenseModalState.fileSelector = expenseModalState.fileSelector.filter(file => file.expenseAttachmentId !== fileToRemove.expenseAttachmentId);
        }
      }
      expenseModalState.form.expenses[0].attachments = expenseModalState.fileSelector;
      updateExpenseLineItem();
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_loader = _resolveComponent("loader");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_chip = _resolveComponent("v-chip");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, {
        loading: expenseModalState.loading
      }, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.isNewExpense ? 'Add New Expense' : 'Edit line item expense'), 1)]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('cancel'))
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [expenseModalState.loading ? (_openBlock(), _createBlock(_component_v_card_text, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_loader, {
            what: 'Expense'
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_v_card_text, {
          key: 1
        }, {
          default: _withCtx(() => [!expenseModalState.loading && !__props.isNewExpense ? (_openBlock(), _createBlock(DescriptionPreviewModal, {
            key: 0,
            "line-item": expenseModalState.form,
            me: expenseModalState.me,
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked)
          }, null, 8, ["line-item", "me", "disabled"])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_component_v_dialog, {
            modelValue: expenseModalState.showRemoveLineModal,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => expenseModalState.showRemoveLineModal = $event), _cache[3] || (_cache[3] = val => val && modalCounters.removeLine++)],
            width: "400",
            attach: '#draft-modal-container',
            scrim: "true",
            persistent: "",
            key: `expense-remove-line-${modalCounters.removeLine}`
          }, {
            default: _withCtx(() => [_createVNode(RemoveLineItemModal, {
              typeLabel: "This Expense",
              onCancel: _cache[1] || (_cache[1] = $event => expenseModalState.showRemoveLineModal = false),
              onConfirm: removeOrDeleteLineItem
            })]),
            _: 1
          }, 8, ["modelValue"])), _createVNode(LlConfirmationDialog, {
            ref_key: "deleteAttachmentDialog",
            ref: deleteAttachmentDialog,
            message: "Are you sure you want to delete this attachment?",
            "confirm-text": "Yes, Delete",
            "toggle-text": "Cancel",
            onConfirm: confirmDeleteAttachment
          }, null, 512), (_openBlock(), _createBlock(_component_v_dialog, {
            modelValue: expenseModalState.showAttachmentPicker,
            "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => expenseModalState.showAttachmentPicker = $event), _cache[6] || (_cache[6] = val => val && modalCounters.attachmentPicker++)],
            width: "700",
            attach: '#draft-modal-container',
            scrim: "true",
            persistent: "",
            key: `expense-attachment-picker-${modalCounters.attachmentPicker}`
          }, {
            default: _withCtx(() => [_createVNode(AttachmentPicker, {
              onClose: _cache[4] || (_cache[4] = $event => expenseModalState.showAttachmentPicker = false),
              onAttachmentSelected: handleSelectedAttachment
            })]),
            _: 1
          }, 8, ["modelValue"])), (_openBlock(), _createBlock(_component_v_dialog, {
            modelValue: expenseModalState.showAttachmentPreview,
            "onUpdate:modelValue": [_cache[8] || (_cache[8] = $event => expenseModalState.showAttachmentPreview = $event), _cache[9] || (_cache[9] = val => val && modalCounters.attachmentPreview++)],
            width: "800",
            attach: '#draft-modal-container',
            scrim: "true",
            persistent: "",
            key: `expense-attachment-preview-${modalCounters.attachmentPreview}`
          }, {
            default: _withCtx(() => [_createVNode(MultipleAttachmentPreview, {
              previewSource: expenseModalState.fileSelector,
              onCancel: _cache[7] || (_cache[7] = $event => expenseModalState.showAttachmentPreview = false),
              selectedFileIndex: expenseModalState.selectedFileIndex
            }, null, 8, ["previewSource", "selectedFileIndex"])]),
            _: 1
          }, 8, ["modelValue"])), __props.isNewExpense ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(LlSelect, {
            modelValue: expenseModalState.form.standard,
            "onUpdate:modelValue": [_cache[10] || (_cache[10] = $event => expenseModalState.form.standard = $event), selectedStandard],
            items: _unref(companySettings).expenses.standard,
            "item-title": "label",
            "item-value": "id",
            "return-object": "",
            placeholder: "Pick an Expense Template",
            label: "Expense Template",
            isAutocomplete: ""
          }, null, 8, ["modelValue", "items"]), _createVNode(LlResizableTextarea, {
            modelValue: expenseModalState.form.description,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => expenseModalState.form.description = $event),
            label: "Description",
            "data-cy": 'expense-description'
          }, null, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(SelectUser, {
            modelValue: expenseModalState.form.account,
            "onUpdate:modelValue": [_cache[12] || (_cache[12] = $event => expenseModalState.form.account = $event), handleAccountChange],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit,
            "use-matter-filtering": true,
            "matter-id": _unref(invoiceState).getCurrentMatterId()
          }, null, 8, ["modelValue", "disabled", "matter-id"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
            class: _normalizeClass(_unref(customFlagLabel) ? 'w-1/2' : 'w-full')
          }, [_createVNode(LlDatePicker, {
            modelValue: expenseModalState.form.date,
            "onUpdate:modelValue": [_cache[13] || (_cache[13] = $event => expenseModalState.form.date = $event), _cache[14] || (_cache[14] = $event => handleDateChange())],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])], 2), _createElementVNode("div", _hoisted_5, [_unref(customFlagLabel) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(LlCheckbox, {
            label: _unref(customFlagLabel),
            modelValue: expenseModalState.form.customFlag,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => expenseModalState.form.customFlag = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["label", "modelValue", "disabled"])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(LlTextField, {
            "data-cy": "expense-amount",
            prefix: '$',
            type: "number",
            label: "Amount",
            modelValue: expenseModalState.form.amount,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => expenseModalState.form.amount = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit,
            rules: [v => !isAmountEmpty(v) || `Amount cannot be left blank`],
            hideDetails: false
          }, null, 8, ["modelValue", "disabled", "rules"])]), _createElementVNode("div", _hoisted_9, [_unref(invoiceState).ledes ? (_openBlock(), _createBlock(ExpenseCodePicker, {
            key: 0,
            modelValue: expenseModalState.form.codes.task,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => expenseModalState.form.codes.task = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit,
            onCodeChange: handleCodeChange
          }, null, 8, ["modelValue", "disabled"])) : _createCommentVNode("", true)])]), _unref(features)?.expenseAttachments ? (_openBlock(), _createElementBlock("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expenseModalState.fileSelector, (file, id) => {
            return _openBlock(), _createElementBlock("div", {
              key: id
            }, [_createElementVNode("div", _hoisted_11, [_withDirectives(_createVNode(_component_v_chip, {
              size: "large",
              variant: "outlined",
              "close-icon": "mdi-delete",
              label: ""
            }, {
              append: _withCtx(() => [_createVNode(_component_v_icon, {
                class: "green-darken-4 mx-2",
                onClick: $event => deleteAttachments(file)
              }, {
                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [_createTextVNode(" mdi-window-close ", -1)]))]),
                _: 1
              }, 8, ["onClick"])]),
              prepend: _withCtx(() => [_withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [[_vShow, file.isQuickBooksAttachment]])]),
              default: _withCtx(() => [_createElementVNode("span", {
                class: "ml-2",
                onClick: $event => {
                  expenseModalState.showAttachmentPreview = true;
                  expenseModalState.selectedFileIndex = id;
                }
              }, _toDisplayString(_unref(truncateFileName)(file.name)), 9, _hoisted_13)]),
              _: 2
            }, 1536), [[_vShow, _unref(permissions)?.expenses?.create]])])]);
          }), 128)), !(_unref(getIsLocked) || _unref(onlyViewInvoice)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
            key: 0,
            class: "mr-2",
            onBtnClick: _cache[18] || (_cache[18] = $event => expenseModalState.showAttachmentPicker = true)
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" Add Attachments ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
          _: 1
        })), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, _createSlots({
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "mr-2",
              onBtnClick: _cache[19] || (_cache[19] = $event => _ctx.$emit('cancel'))
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getIsLocked) || _unref(onlyViewInvoice) ? 'Close' : 'Cancel'), 1)]),
              _: 1
            }), !(__props.isNewExpense || _unref(getIsLocked) || _unref(onlyViewInvoice)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              class: "ml-2",
              "data-cy": "remove-button",
              onBtnClick: _cache[20] || (_cache[20] = $event => removeLineModal())
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" Remove ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 2
          }, [__props.isNewExpense ? {
            name: "append",
            fn: _withCtx(() => [!(_unref(getIsLocked) || _unref(onlyViewInvoice)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              color: "primary",
              variant: "flat",
              isSaving: expenseModalState.isSaving,
              onBtnClick: _cache[21] || (_cache[21] = $event => saveNewExpense()),
              "data-cy": "create-expense",
              disabled: applyDisabled.value
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode(" Create Expense ", -1)]))]),
              _: 1
            }, 8, ["isSaving", "disabled"])) : _createCommentVNode("", true)]),
            key: "0"
          } : {
            name: "append",
            fn: _withCtx(() => [!(_unref(getIsLocked) || _unref(onlyViewInvoice)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              color: "primary",
              variant: "flat",
              onBtnClick: _cache[22] || (_cache[22] = $event => confirm()),
              "data-cy": "save-expense",
              disabled: applyDisabled.value
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" Apply ", -1)]))]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)]),
            key: "1"
          }]), 1024)]),
          _: 1
        })]),
        _: 1
      }, 8, ["loading"]);
    };
  }
};